const formatSize = (sizeInBytes: number) =>
  new Intl.NumberFormat().format(sizeInBytes / 1000);

export default formatSize;
